const config = {
  env: process.env.NODE_ENV,
  publicUrl: process.env.PUBLIC_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  snapPopPath: '/peeppop/1.0',
  audience: process.env.REACT_APP_AUDIENCE,
  clientId: process.env.REACT_APP_WEB_CLIENT_ID,
  clientSecret: process.env.REACT_APP_WEB_CLIENT_SECRET,
  stampCollectionTWId: process.env.REACT_APP_STAMP_COLLECTION_TW_ID,
  stampCollectionYLId: process.env.REACT_APP_STAMP_COLLECTION_YL_ID,
  couponTemplateTWId: process.env.REACT_APP_COUPON_TEMPLATE_TW_ID,
  couponTemplateYLId: process.env.REACT_APP_COUPON_TEMPLATE_YL_ID,
};

export default config;
